/*
  Routes for whole Project
*/

import React from 'react';
import LOCALIZATION from 'services/LocalizationService';

// Application URLs
import URL from "constants/ApplicationUrls";

/* Routes */

const NewmanTanks=React.lazy(()=>import('components/singleProjectDetail'))

const ROUTES = [

 // Single Project Detail
 { path: URL.PROJECT_DETAIL, exact: true, component: NewmanTanks, name:LOCALIZATION.PROJECT_DETAIL }

];

export default ROUTES;